import { useApi } from "./api";


export const useChatService = () => {
  const api = useApi();

  return {
    // Obtener conversaciones recientes
    getRecentConversations: async (limit = 20, offset = 0) => {
      try {
        const response = await api.get("/mssg/conversations", {
          params: { limit, offset },
        });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    // Obtener mensajes de una conversacion
    getConversationMessages: async (conversationId, limit = 50, before = null) => {
      try {
        const response = await api.get(`/mssg/conversations/${conversationId}/messages`, {
          params: { limit, before },
        });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    // Enviar mensaje con archivos
    sendMessage: async ({ conversationId, content, files = [], replyToMessageId, recipientId }) => {
      try {
        const formData = new FormData();
        if (content) formData.append("content", content);
        if (replyToMessageId) formData.append("replyToMessageId", replyToMessageId);
        if (recipientId) formData.append("recipientId", recipientId);
        files.forEach((f) => formData.append("files", f.file || f));

        const url = conversationId
          ? `/mssg/conversations/${conversationId}/messages`
          : `/mssg/messages/send`;

        const response = await api.post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    // Buscar o crear conversacion
    findOrCreateConversation: async (recipientId) => {
      try {
        const response = await api.post("/mssg/conversations/find-or-create", { recipientId });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    // Obtener usuarios agrupados por rol
    getUsersByRole: async () => {
      try {
        const response = await api.get("/mssg/users-by-role");
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    // Editar mensaje
    editMessage: async (messageId, content) => {
      try {
        const response = await api.put(`/mssg/messages/${messageId}`, { content });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    // Eliminar mensaje
    deleteMessage: async (messageId) => {
      try {
        const response = await api.delete(`/mssg/messages/${messageId}`);
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    // Buscar mensajes
    searchMessages: async (query) => {
      try {
        const response = await api.get("/mssg/search", { params: { query } });
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },

    // Marcar conversacion como leida
    markConversationAsRead: async (conversationId) => {
      try {
        const response = await api.post(`/mssg/conversations/${conversationId}/read`);
        return response.data;
      } catch (error) {
        throw error.response?.data || error.message;
      }
    },
  };
};
